import React, { useState } from "react";
import PropTypes from "prop-types";

const PRIORITIES = ["high", "medium", "low"];

export default function BulkActionsBar({ selectedCount, onClearSelection, onExportCsv, onExportExcel, onSetPriority, onDelete, canDelete }) {
  const [showPriorityMenu, setShowPriorityMenu] = useState(false);

  if (selectedCount === 0) return null;

  return (
    <div className="t2t-bulk-bar">
      <span className="fw-semibold" style={{ fontSize: 13 }}>
        {selectedCount} selected
      </span>

      <button
        className="btn btn-sm btn-light text-dark d-flex align-items-center gap-1"
        style={{ fontSize: 12 }}
        onClick={onExportCsv}
        title="Export selected as CSV"
      >
        <i className="bi bi-filetype-csv" />
        CSV
      </button>

      <button
        className="btn btn-sm btn-light text-dark d-flex align-items-center gap-1"
        style={{ fontSize: 12 }}
        onClick={onExportExcel}
        title="Export all (filtered) as Excel"
      >
        <i className="bi bi-file-earmark-excel" />
        Excel
      </button>

      <div className="position-relative">
        <button
          className="btn btn-sm btn-light text-dark d-flex align-items-center gap-1"
          style={{ fontSize: 12 }}
          onClick={() => setShowPriorityMenu(o => !o)}
        >
          <i className="bi bi-flag" />
          Set Priority
          <i className="bi bi-chevron-up" style={{ fontSize: 10 }} />
        </button>
        {showPriorityMenu && (
          <div
            className="bg-white border rounded shadow-sm"
            style={{ position: "absolute", bottom: "calc(100% + 6px)", left: 0, minWidth: 120, zIndex: 200 }}
          >
            {PRIORITIES.map(p => (
              <button
                key={p}
                className="dropdown-item py-2 text-capitalize"
                style={{ fontSize: 13 }}
                onClick={() => { onSetPriority(p); setShowPriorityMenu(false); }}
              >
                {p === "high"   && <i className="bi bi-arrow-up-circle-fill text-danger me-2" />}
                {p === "medium" && <i className="bi bi-dash-circle-fill text-warning me-2" />}
                {p === "low"    && <i className="bi bi-arrow-down-circle-fill text-secondary me-2" />}
                {p}
              </button>
            ))}
          </div>
        )}
      </div>

      {canDelete && (
        <button
          className="btn btn-sm btn-danger d-flex align-items-center gap-1"
          style={{ fontSize: 12 }}
          onClick={onDelete}
          title="Delete selected requests"
        >
          <i className="bi bi-trash3" />
          Delete
        </button>
      )}

      <button
        className="btn btn-sm btn-link text-white text-decoration-none ms-auto p-0"
        style={{ fontSize: 12 }}
        onClick={onClearSelection}
      >
        <i className="bi bi-x-lg me-1" />Clear
      </button>
    </div>
  );
}

BulkActionsBar.propTypes = {
  selectedCount:    PropTypes.number.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  onExportCsv:      PropTypes.func.isRequired,
  onExportExcel:    PropTypes.func.isRequired,
  onSetPriority:    PropTypes.func.isRequired,
  onDelete:         PropTypes.func,
  canDelete:        PropTypes.bool,
};
